<ion-modal
  trigger="passenger-count-modal"
  class="passenger-count-modal"
  handleBehavior="cycle"
>
  <ng-template>
    <ion-header class="ion-no-border">
      <ion-toolbar class="no-safe-area-top">
        <ion-title class="fs-5 font600">Select travellers</ion-title>
        <ion-icon
          class="primary-icon-color marr10"
          name="close-outline"
          size="large"
          slot="end"
          (click)="closeModal()"
        ></ion-icon>
      </ion-toolbar>
    </ion-header>

    <div class="ion-padding passenger-count-body">
      <div
        class="d-flex ion-justify-content-between ion-align-items-center marb10"
      >
        <div>
          <p class="fs-3 font600 ion-no-margin">
            {{ (passenger?.adult < 2 ? "flight.passenger_count_modal.adult" : "flight.passenger_count_modal.adults") | translate }}
          </p>
          <p class="fs-2 font600 ion-no-margin subtitle-text-color">
            (12+ {{ "flight.passenger_count_modal.years" | translate }})
          </p>
        </div>
        <counter-buttons
          (addFunction)="add('adult')"
          (removeFunction)="subtract('adult')"
          [item]="'adult'"
          [quantity]="passenger?.adult"
          [containerStyle]="{
            'min-width': '131px',
            height: '40px',
            'border-radius': '5px'
          }"
        ></counter-buttons>
      </div>
      <div *ngIf="displayErrors.adult" class="error-message marb10">
        <ion-text color="danger">
          <p class="fs-2 ion-no-margin">
            <ion-icon name="alert-circle-outline" size="small"></ion-icon>
            {{ displayErrors.adult }}
          </p>
        </ion-text>
      </div>

      <div
        class="d-flex ion-justify-content-between ion-align-items-center marb10"
      >
        <div>
          <p class="fs-3 font600 ion-no-margin">
            {{ (passenger?.child < 2 ? "flight.passenger_count_modal.child" : "flight.passenger_count_modal.children") | translate }}
          </p>
          <p class="fs-2 font600 ion-no-margin subtitle-text-color">
            (2-11 {{ "flight.passenger_count_modal.years" | translate }})
          </p>
        </div>
        <counter-buttons
          (addFunction)="add('child')"
          (removeFunction)="subtract('child')"
          [item]="'child'"
          [quantity]="passenger?.child"
          [containerStyle]="{
            'min-width': '131px',
            height: '40px',
            'border-radius': '5px'
          }"
        ></counter-buttons>
      </div>
      <div *ngIf="displayErrors.child" class="error-message marb10">
        <ion-text color="danger">
          <p class="fs-2 ion-no-margin">
            <ion-icon name="alert-circle-outline" size="small"></ion-icon>
            {{ displayErrors.child }}
          </p>
        </ion-text>
      </div>

      <div
        class="d-flex ion-justify-content-between ion-align-items-center marb10"
      >
        <div>
          <p class="fs-3 font600 ion-no-margin">
            {{ (passenger?.infant < 2 ? "flight.passenger_count_modal.infant" : "flight.passenger_count_modal.infants") | translate }}
          </p>
          <p class="fs-2 font600 ion-no-margin subtitle-text-color">
            ({{ "flight.passenger_count_modal.below" | translate }} 2
            {{ "flight.passenger_count_modal.years" | translate }})
          </p>
        </div>
        <counter-buttons
          (addFunction)="add('infant')"
          (removeFunction)="subtract('infant')"
          [item]="'infant'"
          [quantity]="passenger?.infant"
          [containerStyle]="{
            'min-width': '131px',
            height: '40px',
            'border-radius': '5px'
          }"
        ></counter-buttons>
      </div>
      <div *ngIf="displayErrors.infant" class="error-message marb10">
        <ion-text color="danger">
          <p class="fs-2 ion-no-margin">
            <ion-icon name="alert-circle-outline" size="small"></ion-icon>
            {{ displayErrors.infant }}
          </p>
        </ion-text>
      </div>

      <div class="ion-margin-top ion-padding-top">
        <ion-label class="fs-5 font600">Select travel class</ion-label>
      </div>
      <ion-radio-group
        [(ngModel)]="travelClass"
        (ionChange)="emitPassengerData()"
        class="class"
        [disabled]="isEconomyOnlyMode()"
      >
        <ion-list lines="none">
          <ion-item>
            <ion-label>{{
              "flight.flights_search.economy" | translate
            }}</ion-label>
            <ion-radio slot="start" value="Economy"></ion-radio>
          </ion-item>
          <ion-item *ngIf="!isEconomyOnlyMode()">
            <ion-label>{{
              "flight.flights_search.premium_economy" | translate
            }}</ion-label>
            <ion-radio slot="start" value="PremiumEconomy"></ion-radio>
          </ion-item>
          <ion-item *ngIf="!isEconomyOnlyMode()">
            <ion-label>{{
              "flight.flights_search.business" | translate
            }}</ion-label>
            <ion-radio slot="start" value="Business"></ion-radio>
          </ion-item>
          <ion-item *ngIf="!isEconomyOnlyMode()">
            <ion-label>{{
              "flight.flights_search.first" | translate
            }}</ion-label>
            <ion-radio slot="start" value="First"></ion-radio>
          </ion-item>
        </ion-list>
      </ion-radio-group>
    </div>

    <ion-footer class="ion-no-border passenger-count-footer">
      <ion-toolbar>
        <ion-button
          class="ion-margin primary-btn"
          expand="block"
          mode="ios"
          (click)="closeModal()"
          [disabled]="!isValidPassengerCount()"
        >
          {{ "flight.passenger_count_modal.done" | translate }}
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
